const Components = {
    ACTIONS: "actions",
    ADD_LTP_USER: "addLtpUser",
    APPLICATION: "application",
    ASSESSMENT_TYPE_LIST: "assessment_type_list",
    FINANCE: "finance",
    FORGOT_PASSWORD: "forgot_password",
    HOME: "home",
    INTERMEDIATE_REPORT: "intermediate_report",
    LOGIN: "login",
    MENU: "menu",
    ORGANISATION_SETTINGS: "organisation_settings",
    PARTICIPANT_DETAIL: "participant_detail",
    PARTICIPANT_FILE_UPLOADER: "participant_file_uploader",
    PARTICIPANTS: "participants",
    PARTICIPANTS_FILTER: "participants_filter",
    PARTICIPANTS_REQUEST_ASSESSMENT: "participantsRequestAssessment",
    PROFILE: "profile",
    PROJECT_FILE_UPLOADER: "project_file_uploader",
    QUESTIONNAIRE_BUILDER: "questionnaire_builder",
    REPORT: "report",
    RESERVATION: "reservation",
    RESULTS: "results",
    TALENT_ANALYTICS: "talentAnalytics",
    TALENT_ANALYTICS_SETTINGS: "talentAnalyticsSettings",
    TEAMS: "teams",
    USERS: "users",
};

export default Components;
